import { render, staticRenderFns } from "./PmNoRealTaskRightList.vue?vue&type=template&id=08b41be3&"
import script from "./PmNoRealTaskRightList.vue?vue&type=script&lang=js&"
export * from "./PmNoRealTaskRightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports